import Vue from 'vue'
import _ from 'lodash'
import globalMixin from '@/mixins/global'

function register(context, action) {
  _.forEach(context.keys(), fileName => {
    const componentConfig = context(fileName)
    const name = fileName.split('/').pop().replace(/\.\w+$/, '')
    action(name, componentConfig)
  })
}

//

function registerComponents() {
  register(require.context('@/components', true, /\w+\.(vue)$/), (name, componentConfig) => {
    const componentPrefix = 'Oie'
    const componentName = componentPrefix + _.chain(name).camelCase().upperFirst().value()
    Vue.component(componentName, componentConfig.default || componentConfig)
  })

  // register(require.context('@/components/svg', true, /\w+\.(vue)$/), (name, componentConfig) => {
  //   const componentName = _.chain(name).camelCase().upperFirst().value()
  //   Vue.component(componentName, componentConfig.default || componentConfig)
  // })
}

function registerDirectives() {
  register(require.context('@/directives', false, /\w+\.(js)$/), (name, componentConfig) => {
    Vue.directive(name, componentConfig.default || componentConfig)
  })
}

function registerGlobalMixin() {
  Vue.mixin(globalMixin)
}

registerGlobalMixin()
registerComponents()
registerDirectives()
